import { type MetricConfiguration } from "@tokenterminal/tt-analytics-api-types/dist/api/metrics"
import type { Trend } from "./types"

interface TrendProps {
  metric_change?: null | number
  metricConfig: MetricConfiguration
}

export const calculateTrend = ({
  metric_change,
  metricConfig,
}: TrendProps): Trend => {
  if (typeof metric_change !== "number" || !metric_change) {
    // Neutral trend
    return
  }

  if (metricConfig.is_lower_value_better) {
    if (metric_change > 0) {
      return "negative"
    } else {
      return "positive"
    }
  } else {
    if (metric_change > 0) {
      return "positive"
    } else {
      return "negative"
    }
  }
}
